var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn btn-success mr-2",on:{"click":_vm.copyToClipboard}},[_c('i',{staticClass:"far fa-copy"})])
}
var staticRenderFns = []

export { render, staticRenderFns }